<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
            <b-row>
              <b-col lg="12" sm="12">
                  <b-overlay :show='loading'>
                    <iq-card>
                        <template v-slot:headerTitle>
                          <h4 class="card-title">{{ $t('externalUser.stall_participant_information') }}</h4>
                        </template>
                        <template v-slot:headerAction>
                          <router-link to="/stall-participant/profile-update" variant="primary" :class="'btn btn-success text-light'">{{ $t('external_sidebar.profile') }} {{ $t('globalTrans.update') }}</router-link>
                          <b-button variant="primary" @click="pdfExport">
                            {{  $t('globalTrans.export_pdf') }}
                          </b-button>
                        </template>
                        <template v-slot:body>
                            <b-row>
                              <b-col lg="12" sm="12" class="text-center mb-4">
                                <h5 class='complain-title' style="font-weight: bold">{{ $t('externalUser.profile_info_details') }}</h5>
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col lg="3" sm="12">
                                <div class="d-flex align-items-center" style="height:250px" v-if="formData.org_logo">
                                  <b-img class="mb-2" style='border-1px solid;width:150px;max-height:200px' @error="imageLoadError()" fluid :src="awarenessEventServiceBaseUrl + 'storage/' + formData.org_logo"  alt="Org Logo"></b-img>
                                </div>
                              </b-col>
                              <b-col lg="9" sm="12">
                                  <div>
                                      <table class="table table-sm table-striped table-hover">
                                          <tbody>
                                              <b-tr>
                                                  <b-th style="width:30%">{{$t('production_service_config.reg_no')}}</b-th>
                                                  <b-th style="width:5%">:</b-th>
                                                  <b-th>{{ formData.registration_id }}</b-th>
                                              </b-tr>
                                              <b-tr>
                                                  <b-th>{{$t('retailerManagement.email')}}</b-th>
                                                  <b-th>:</b-th>
                                                  <b-th>{{ formData.email }}</b-th>
                                              </b-tr>
                                              <b-tr>
                                                  <b-th>{{$t('externalUser.org_name')}}</b-th>
                                                  <b-th>:</b-th>
                                                  <b-th>{{ $i18n.locale=='bn' ? formData.org_name_bn : formData.org_name }}</b-th>
                                              </b-tr>
                                              <b-tr>
                                                  <b-th>{{$t('externalUser.contact_person_name')}}</b-th>
                                                  <b-th>:</b-th>
                                                  <b-th>{{ $i18n.locale=='bn' ? formData.contact_person_name_bn : formData.contact_person_name }}</b-th>
                                              </b-tr>
                                              <b-tr>
                                                  <b-th>{{$t('retailerManagement.contact_no')}}</b-th>
                                                  <b-th>:</b-th>
                                                  <b-th>{{ $i18n.locale=='bn' ? '০' : '0' }}{{ $n(formData.contact_no, { useGrouping: false }) }}</b-th>
                                              </b-tr>
                                              <b-tr>
                                                  <b-th>{{$t('retailerManagement.nid')}}</b-th>
                                                  <b-th>:</b-th>
                                                  <b-th>{{ $n(formData.nid_no, { useGrouping: false }) }}</b-th>
                                              </b-tr>
                                              <b-tr>
                                                  <b-th>{{$t('production_service_config.nid_attach')}}</b-th>
                                                  <b-th>:</b-th>
                                                  <b-th>
                                                      <a target = '_blank' v-if="formData.nid_file" :href="awarenessEventServiceBaseUrl + 'storage/' + formData.nid_file" download>{{ $t('globalTrans.view') }}</a>
                                                  </b-th>
                                              </b-tr>
                                          </tbody>
                                      </table>
                                  </div>
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col lg="12" sm="12" class="text-center mb-4">
                                <h5 class='complain-title' style="font-weight: bold">{{ $t('externalUser.organization_address') }}</h5>
                              </b-col>
                            </b-row>
                            <b-row>
                                <b-col lg="12" sm="12">
                                    <div>
                                        <table class="table table-sm table-striped table-hover">
                                          <tbody>
                                              <b-tr>
                                                  <b-th style="width:25%" scope="col">{{ $t('org_pro.area_type') }}</b-th>
                                                  <b-th  style="width:5%">:</b-th>
                                                  <b-th style="" scope="col">{{ ($i18n.locale=='bn') ? formData.area_name_bn : formData.area_name }}</b-th>
                                              </b-tr>
                                              <b-tr>
                                                  <b-th style="" class="" scope="row">{{ $t('org_pro_division.division') }}</b-th>
                                                  <b-th>:</b-th>
                                                  <b-th style="" class="">{{ ($i18n.locale=='bn') ? formData.division_name_bn : formData.division_name }}</b-th>
                                              </b-tr>
                                              <b-tr>
                                                  <b-th style="" scope="row">{{ $t('org_pro_district.district') }}</b-th>
                                                  <b-th>:</b-th>
                                                  <b-th style="">{{ ($i18n.locale=='bn') ? formData.district_name_bn : formData.district_name }}</b-th>
                                              </b-tr>
                                              <b-tr v-if="formData.area_type_id == 3||2">
                                                  <b-th style="" scope="row">{{ $t('org_pro_upazilla.upazilla')}} </b-th>
                                                  <b-th>:</b-th>
                                                  <b-th style="">{{ ($i18n.locale=='bn') ? formData.upazilla_name_bn : formData.upazilla_name }}</b-th>
                                              </b-tr>
                                              <b-tr v-if="formData.area_type_id == 3">
                                                  <b-th style="" scope="row">{{ $t('org_pro_union.union') }}</b-th>
                                                  <b-th>:</b-th>
                                                  <b-th style="">{{ ($i18n.locale=='bn') ? formData.union_name_bn : formData.union_name }}</b-th>
                                              </b-tr>
                                              <b-tr v-if="formData.area_type_id == 1">
                                                  <b-th style="" scope="row">{{ $t('org_pro.city_corporation') }}</b-th>
                                                  <b-th>:</b-th>
                                                  <b-th style="">{{ ($i18n.locale=='bn') ? formData.cityCorporation_name_bn : formData.cityCorporation_name }}</b-th>
                                              </b-tr>
                                              <b-tr v-if="formData.area_type_id == 3||2">
                                                  <b-th style="" scope="row">{{ $t('org_pro.ward') }}</b-th>
                                                  <b-th>:</b-th>
                                                  <b-th style="">{{ ($i18n.locale=='bn') ? formData.ward_name_bn : formData.ward_name }}</b-th>
                                              </b-tr>
                                              <b-tr v-if="formData.area_type_id == 2">
                                                  <b-th style="" scope="row">{{ $t('org_pro.pauroshoba') }}</b-th>
                                                  <b-th>:</b-th>
                                                  <b-th style="">{{ ($i18n.locale=='bn') ? formData.pauroshoba_name_bn : formData.pauroshoba_name }}</b-th>
                                              </b-tr>
                                              <b-tr>
                                                  <b-th>{{$t('globalTrans.address')}}</b-th>
                                                  <b-th>:</b-th>
                                                  <b-th>{{ ($i18n.locale=='bn') ? formData.address_bn : formData.address }}</b-th>
                                              </b-tr>
                                          </tbody>
                                        </table>
                                    </div>
                                </b-col>
                            </b-row>
                        </template>
                    </iq-card>
                  </b-overlay>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
      <!-- <pre>{{formData}}</pre> -->
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import RestApi, { awarenessEventServiceBaseUrl } from '@/config/api_config'
import { stallParticipantProfileShow } from '../../api/routes'
import ExportPdf from './export-pdf_details'

export default {
  props: ['id'],
  components: {
  },
  created () {
    // this.checkRetailer()
    const userId = this.$store.state.Auth.authUser.id
    if (userId) {
      this.getUserInfo(userId)
    }
  },
  mounted () {
    core.index()
  },
  data () {
    return {
        saved: false,
        isApproved: false,
        awarenessEventServiceBaseUrl: awarenessEventServiceBaseUrl,
        formData: {
            id: '',
            save_status: 1,
            user_id: '',
            org_name: '',
            org_name_bn: '',
            contact_person_name: '',
            contact_person_name_bn: '',
            contact_no: '',
            area_type_id: 0,
            city_corporation_id: 0,
            pauroshoba_id: 0,
            disable_type_id: 0,
            division_id: 0,
            district_id: 0,
            upazilla_id: 0,
            union_id: 0,
            ward_id: 0,
            address: '',
            address_bn: '',
            nid_no: '',
            nid_file: '',
            org_logo: ''
        }
    }
  },
  computed: {
    loading () {
        return this.$store.state.ExternalUser.static.loading
    }
  },
  watch: {
  },
  methods: {
    pdfExport () {
      const reportTitle = this.$t('externalUser.stall_participant_information')
      ExportPdf.exportPdfDetails(reportTitle, this.formData, this)
    },
    async getUserInfo (id) {
        this.$store.dispatch('ExternalUser/mutateExternalFormLoad', { loading: true })
        const result = await RestApi.getData(awarenessEventServiceBaseUrl, stallParticipantProfileShow)
        this.$store.dispatch('ExternalUser/mutateExternalFormLoad', { loading: false })
        if (result.success) {
            if (result.data.save_status === 2) {
                this.saved = true
            }
            this.formData = result.data
            const areaObj = this.$store.state.commonObj.wardTypeList.find(area => area.id === parseInt(this.formData.area_type_id))
            if (typeof areaObj !== 'undefined') {
              this.formData.area_name = areaObj.name
              this.formData.area_name_bn = areaObj.name_bn
            } else {
              this.formData.area_name = ''
              this.formData.area_name_bn = ''
            }
            const perareaObj = this.$store.state.commonObj.wardTypeList.find(area => area.id === parseInt(this.formData.area_type_id))
            if (typeof perareaObj !== 'undefined') {
              this.formData.per_area_name = perareaObj.name
              this.formData.per_area_name_bn = perareaObj.name_bn
            } else {
              this.formData.per_area_name = ''
              this.formData.per_area_name_bn = ''
            }
            const divisionObj = this.$store.state.ExternalUser.commonObj.divisionList.find(division => division.value === parseInt(this.formData.division_id))
            if (typeof divisionObj !== 'undefined') {
              this.formData.division_name = divisionObj.text_en
              this.formData.division_name_bn = divisionObj.text_bn
            } else {
              this.formData.division_name = ''
              this.formData.division_name_bn = ''
            }
            const districtObj = this.$store.state.ExternalUser.commonObj.districtList.find(district => district.value === parseInt(this.formData.district_id))
            if (typeof divisionObj !== 'undefined') {
              this.formData.district_name = districtObj.text_en
              this.formData.district_name_bn = districtObj.text_bn
            } else {
              this.formData.district_name = ''
              this.formData.district_name_bn = ''
            }
            const upazillaObj = this.$store.state.ExternalUser.commonObj.upazilaList.find(upazilla => upazilla.value === parseInt(this.formData.upazilla_id))
            if (typeof upazillaObj !== 'undefined') {
              this.formData.upazilla_name = upazillaObj.text_en
              this.formData.upazilla_name_bn = upazillaObj.text_bn
            } else {
              this.formData.upazilla_name = ''
              this.formData.upazilla_name_bn = ''
            }
            const cityCorporationObj = this.$store.state.ExternalUser.commonObj.cityCorporationList.find(cityCorporation => cityCorporation.value === parseInt(this.formData.city_corporation_id))
            if (typeof cityCorporationObj !== 'undefined') {
              this.formData.cityCorporation_name = cityCorporationObj.text_en
              this.formData.cityCorporation_name_bn = cityCorporationObj.text_bn
            } else {
              this.formData.cityCorporation_name = ''
              this.formData.cityCorporation_name_bn = ''
            }
            const unionObj = this.$store.state.ExternalUser.commonObj.unionList.find(union => union.value === parseInt(this.formData.union_id))
            if (typeof unionObj !== 'undefined') {
              this.formData.union_name = unionObj.text_en
              this.formData.union_name_bn = unionObj.text_bn
            } else {
              this.formData.union_name = ''
              this.formData.union_name_bn = ''
            }
            const wardObj = this.$store.state.ExternalUser.commonObj.wardList.find(ward => ward.value === parseInt(this.formData.ward_id))
            if (typeof wardObj !== 'undefined') {
              this.formData.ward_name = wardObj.text_en
              this.formData.ward_name_bn = wardObj.text_bn
            } else {
              this.formData.ward_name = ''
              this.formData.ward_name_bn = ''
            }
            const pauroshobaObj = this.$store.state.ExternalUser.commonObj.pauroshobaList.find(per => per.value === parseInt(this.formData.pauroshoba_id))
            if (typeof pauroshobaObj !== 'undefined') {
              this.formData.pauroshoba_name = pauroshobaObj.text_en
              this.formData.pauroshoba_name_bn = pauroshobaObj.text_bn
            } else {
              this.formData.pauroshoba_name = ''
              this.formData.pauroshoba_name_bn = ''
            }
        } else {
            this.$router.push({ name: 'external_user.stall_participant.profile_update' })
        }
    }
  }
}
</script>
